import { loadConfig } from './config'

loadConfig()
  .then(() => {
    import('./bootstrap')
  })
  .catch((err) => {
    document.body.innerHTML = `<pre>Failed to load config: ${String(err)}</pre>`
  })
